import {
  IconBell,
  IconChecklist,
  IconCreditCard,
  IconFileText,
  IconLayoutDashboard,
  IconReceipt,
  IconSettings,
  IconShield,
  IconUsers,
  IconWallet,
  type Icon,
} from '@tabler/icons-react';
import type { BusinessNavIcon as BusinessNavIconKey } from './businessNav.js';

const BY_ICON: Record<BusinessNavIconKey, Icon> = {
  overview: IconLayoutDashboard,
  people: IconUsers,
  policies: IconShield,
  approvals: IconChecklist,
  budgets: IconWallet,
  invoices: IconReceipt,
  reports: IconFileText,
  settings: IconSettings,
  alerts: IconBell,
};

export function BizNavIcon({ icon, size = 18 }: { icon: BusinessNavIconKey; size?: number }) {
  const Cmp = BY_ICON[icon] ?? IconCreditCard;
  return <Cmp size={size} stroke={1.5} aria-hidden className="shrink-0 opacity-80" />;
}
